export default function () {
  const burgerButton = window.document.querySelector('.c-hamburger');
  const menuWrapper = window.document.querySelector('.navm__wrapper');
  const menuPage = window.document.querySelector('.navm__page');
  const menuLink = window.document.querySelectorAll('.navm__link');
  const menuBack = window.document.querySelector('.navm-back');
  const menuChildren = window.document.querySelectorAll('.navm__list-wrapper  ');
  const duration = 350;

  /**
   * Get navigation transform-X position
   *
   * @returns {number}
   */
  function getTransform() {
    let transform = 0;
    if (menuWrapper.hasAttribute('style')) {
      const [, part2] = menuWrapper.style.transform.split(/[()]/);
      transform = parseInt(part2, 10);
    }
    return transform;
  }

  /**
   * Set navigation transform-X position
   *
   * @param transform
   */
  function setTransform(transform = 0) {
    menuWrapper.style.transform = `translateX(${transform}px)`;
    menuWrapper.style.transitionDuration = `${duration}ms`;
  }

  /**
   * Prevent mobile menu item from double-clock
   *
   * @param item
   */
  function menuLinkBlock(item) {
    item.classList.add('blocked');
  }

  /**
   * Release all of previously blocked mobile menu items
   */
  function menuLinkReleaseAll() {
    menuLink.forEach((item) => {
      item.classList.remove('blocked');
    });
  }

  /**
   * Toggle navigation pagination
   *
   * Move forward: next = true
   * Move Backward: next = false (by default)
   *
   * @param next
   * @returns {boolean}
   */
  function togglePage(next = false) {
    if (next === true) {
      setTransform(getTransform() - menuPage.clientWidth);
      return false;
    }
    setTransform(getTransform() + menuPage.clientWidth);
    menuLinkReleaseAll();
    return false;
  }

  /**
   * Activate current submenu
   *
   * @param id
   */
  function toggleChildren(id) {
    const menuChildrenActive = window.document.getElementById(id);
    menuChildren.forEach((item) => {
      item.classList.remove('open');
    });
    menuChildrenActive.classList.add('open');
  }

  /**
   * Reset navigation pagination to default state
   */
  function resetAll() {
    setTransform();
    menuChildren.forEach((item) => {
      item.classList.remove('open');
    });
  }

  menuLink.forEach((item) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('has-children') && !item.classList.contains('blocked')) {
        const target = item.getAttribute('data-target');
        menuLinkBlock(item);
        togglePage(true);
        toggleChildren(target);
      }
    });
  });

  menuBack.addEventListener('click', () => {
    togglePage();
  });

  burgerButton.addEventListener('click', () => {
    if (!burgerButton.classList.contains('open')) {
      resetAll();
      menuLinkReleaseAll();
    }
  });

  window.addEventListener('resize', () => {
    resetAll();
  });

  document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
}
